import util from '@bmp-vue/core/api/util';

const controller = 'Dashboard';
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']));
